import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { class: "profile-img-wrapper" }
const _hoisted_5 = { class: "profile-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "profile-info" }
const _hoisted_8 = { class: "profile-attr-gender" }
const _hoisted_9 = { id: "attribute" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "profile-nickname"
}
const _hoisted_12 = { id: "nickname" }
const _hoisted_13 = { class: "profile-wrapper" }
const _hoisted_14 = { id: "users" }
const _hoisted_15 = {
  class: "contents-profile-setting",
  id: "hospital_name"
}
const _hoisted_16 = {
  class: "contents-profile-setting",
  id: "disease_name"
}
const _hoisted_17 = {
  class: "contents-profile-setting",
  id: "tag_name"
}
const _hoisted_18 = {
  class: "contents-profile-setting",
  id: "zip_code"
}
const _hoisted_19 = {
  class: "contents-profile-setting",
  id: "user_login_id"
}
const _hoisted_20 = {
  class: "contents-profile-setting",
  id: "birth_date"
}
const _hoisted_21 = {
  class: "contents-profile-setting",
  id: "status_patient_group"
}
const _hoisted_22 = {
  class: "contents-profile-setting",
  id: "identify_code"
}
const _hoisted_23 = {
  class: "contents-profile-setting",
  id: "password"
}
const _hoisted_24 = { class: "password-area" }

import { ref, reactive, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import { Profile } from "@/models/profile/profile";

import CommonMessage from "@/views/base/CommonMessage.vue";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose04-01";
const menuId = "profile";
type ProfileInfo = {
  userloginid: string;
  attribute: number;
  attributelabel: string;
  nickname: string;
  image: string;
  birthdate: string;
  zipcode: string;
  gender: string;
  genderlabel: string;
  identifycode: string;
  hospitalnames: string; //表示するため文字列で受け取る
  diseasecodes: string[];
  diseasenames: string;
  otherdiseasename: string;
  tagids: string[];
  tagnames: string;
  isStakeholder: boolean;
  statuspatientgroup: string;
  statuspatientgrouplabel: string;
};

// ---- Variable ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const router = useRouter();
const profile = new Profile();
const previewImage = ref("/server/necs/images/profile_icon.png");
// ---- Types -------------------------------------------------
const profileInfo = ref<ProfileInfo>({
  userloginid: "",
  attribute: 0,
  attributelabel: "",
  nickname: "",
  image: "",
  birthdate: "",
  zipcode: "",
  gender: "",
  genderlabel: "",
  identifycode: "",
  hospitalnames: "",
  diseasecodes: [],
  diseasenames: "",
  otherdiseasename: "",
  tagids: [],
  tagnames: "",
  isStakeholder: false,
  statuspatientgroup: "",
  statuspatientgrouplabel: "",
});

// ----- Function -----------------------------------------------
// メッセージダイアログ関連情報
let sessionErr = ref(false);
let messageConfig = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing();
    messageConfig.message = message;
    messageConfig.show = true;
  },
  close: (): void => {
    processend();
    messageConfig.show = false;
    messageConfig.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});
// ----- Function -----------------------------------------------
// プロフィール情報取得
const fetchProfileInfo = async () => {
  await profile.getProfileInfo().then(([model, _response, err]) => {
    if (err) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      const status = err.error.response.status;
      if (status === 408) sessionErr.value = true;
      messageConfig.open(decodedMessage);
      return;
    } else {
      profileInfo.value = model.attributes?.result || null;
      if (profileInfo.value.image) {
        previewImage.value = profileInfo.value.image;
      }
    }
  });
};

// 生年月日フォーマット
const formattedBirthday = computed(() => {
  if (!profileInfo.value.birthdate) return "";
  const [year, month, day] = profileInfo.value.birthdate.split("/");
  return `${year}年${parseInt(month)}月${parseInt(day)}日`;
});

// 編集ボタン押下
const gotoEdit = () => {
  router.push({ name: "ProfileEdit" });
};
// パスワード変更ボタン押下
const gotoChangePassword = () => {
  router.push({ name: "Password" });
};

onMounted(async () => {
  await fetchProfileInfo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { activeMenu: menuId }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("profile_title")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: previewImage.value,
                alt: "Preview"
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(profileInfo.value.attributelabel), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, " / ", -1)),
                  (profileInfo.value.genderlabel !== _ctx.$t('profile_not_answer'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(profileInfo.value.genderlabel), 1))
                    : _createCommentVNode("", true)
                ]),
                (profileInfo.value.nickname)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(profileInfo.value.nickname), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "profile-nickname-honor" }, "さん", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "button-icon-edit",
              onClick: gotoEdit
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("img", { src: "/server/necs/images/edit_24dp_FILL1_wght400_GRAD0_opsz24.png" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile_edit_button_name")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_15, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_hospital_name")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.hospitalnames), 1)
                ]),
                _createElementVNode("tr", _hoisted_16, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_disease_name")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.isStakeholder
                      ? _ctx.$t("profile_disease_stakeholder")
                      : (profileInfo.value.diseasenames || "") +
                        (profileInfo.value.diseasenames &&
                        profileInfo.value.otherdiseasename
                          ? ", "
                          : "") +
                        (profileInfo.value.otherdiseasename
                          ? _ctx.$t("profile_disease_other_colon") +
                            profileInfo.value.otherdiseasename
                          : "")), 1)
                ]),
                _createElementVNode("tr", _hoisted_17, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_interest")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.tagnames), 1)
                ]),
                _createElementVNode("tr", _hoisted_18, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_zipcode")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.zipcode), 1)
                ]),
                _createElementVNode("tr", _hoisted_19, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_mailaddress")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.userloginid), 1)
                ]),
                _createElementVNode("tr", _hoisted_20, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_birthdate")), 1),
                  _createElementVNode("td", null, _toDisplayString(formattedBirthday.value), 1)
                ]),
                _createElementVNode("tr", _hoisted_21, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_status_patient_group")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.statuspatientgrouplabel), 1)
                ]),
                _createElementVNode("tr", _hoisted_22, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_identify_code")), 1),
                  _createElementVNode("td", null, _toDisplayString(profileInfo.value.identifycode || _ctx.$t("profile_none_identify_code")), 1)
                ]),
                _createElementVNode("tr", _hoisted_23, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_password")), 1),
                  _createElementVNode("td", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.$t("profile_password_constvalue")) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "button-icon-password",
                      onClick: gotoChangePassword
                    }, [
                      _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/server/necs/images/lock_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.png" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile_change_password")), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (_unref(messageConfig).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 0 }, _unref(messageConfig), {
          onOk: _unref(messageConfig).close,
          onCancel: _unref(messageConfig).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})